import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzoresIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_619)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 16.5485 2.53078 20.5057 6.26086 22.5409V1.45908C2.53078 3.4943 0 7.45148 0 12Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 17.5443 3.76036 22.2096 8.86955 23.5866V0.413391C3.76036 1.79039 0 6.45567 0 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.30434 4.17389V6.1304C4.30434 7.10292 5.09269 7.89126 6.0652 7.89126C7.03772 7.89126 7.82606 7.10292 7.82606 6.1304V4.17389H4.30434Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.0652 6.84783C5.66962 6.84783 5.34782 6.52603 5.34782 6.13045V5.21742H6.78262V6.13045C6.78262 6.52603 6.46078 6.84783 6.0652 6.84783Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.0435 12.5217H9.91303C9.91303 11.9454 9.44583 11.4782 8.86954 11.4782C8.29326 11.4782 7.82606 11.9454 7.82606 12.5217H4.69561C4.69561 13.098 5.19759 13.5652 5.77383 13.5652H5.73909C5.73909 14.1415 6.2062 14.6087 6.78258 14.6087C6.78258 15.185 7.24969 15.6522 7.82606 15.6522H9.91303C10.4893 15.6522 10.9565 15.185 10.9565 14.6087C11.5328 14.6087 12 14.1415 12 13.5652H11.9653C12.5415 13.5652 13.0435 13.098 13.0435 12.5217Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.4723 10.8519L13.1984 11.2905L13.5307 11.6865L13.0289 11.5616L12.7549 12L12.7188 11.4841L12.217 11.359L12.6966 11.1653L12.6605 10.6495L12.9929 11.0457L13.4723 10.8519Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.8737 9.51056L11.7663 10.0164L12.2141 10.2749L11.6998 10.3292L11.5923 10.8349L11.382 10.3625L10.8677 10.4165L11.252 10.0704L11.0417 9.59812L11.4895 9.85664L11.8737 9.51056Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.91294 8.79694L9.9849 9.30905L10.4941 9.39881L10.0294 9.6255L10.1013 10.1376L9.74218 9.76561L9.27736 9.9923L9.52013 9.53569L9.16093 9.16378L9.67022 9.2535L9.91294 8.79694Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.8262 8.79694L8.06902 9.2535L8.57822 9.16373L8.21902 9.53578L8.46178 9.99234L7.99706 9.76561L7.63781 10.1375L7.70981 9.6255L7.24505 9.39886L7.75425 9.30905L7.8262 8.79694Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.86537 9.51056L6.24966 9.85664L6.69741 9.59812L6.48722 10.0706L6.87136 10.4165L6.35719 10.3625L6.14676 10.8349L6.03942 10.3291L5.52511 10.2751L5.97286 10.0164L5.86537 9.51056Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.26685 10.8519L4.74642 11.0457L5.07863 10.6495L5.04272 11.1655L5.52211 11.3592L5.02031 11.4842L4.98413 12L4.71033 11.5616L4.20858 11.6866L4.54097 11.2905L4.26685 10.8519Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_619",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgAzoresIslands;
